import { CopySlice } from '../../prismicio-types'
import { asHTML, HTMLRichTextMapSerializer } from '@prismicio/client'
import styles from './Copy.module.css'
import linkResolver from '../linkResolver'
import { ResponsiveImage } from './ResponsiveImage'
import { Embed } from './Embed'

const serializer: HTMLRichTextMapSerializer = {
	image: ({ node }) =>
		`<div class="${styles.Image}">${ResponsiveImage.render({ image: node, sizes: '(min-width: 1440px) 50vw, (min-width: 768px) 60vw, 95vw' })}</div>`,
	embed: ({ node }) => Embed.render({ embed: node.oembed })
}

export class Copy {
	static render(props: CopySlice) {
		const {
			primary: { text }
		} = props

		return /* HTML */ ` <div class="${styles.Main}">${asHTML(text, { linkResolver, serializer })}</div> `
	}
}
